import { CreateExchangeTheme } from './create-exchange';
import { ExchangeControlsWrapper } from './exchange-route-controls';
import { RefuseExchangeTheme } from './refuse-exchange';
import { SelectDateTheme } from './select-date';

export default {
	...CreateExchangeTheme,
	...ExchangeControlsWrapper,
	...RefuseExchangeTheme,
	...SelectDateTheme
};
